import { positionHelperModule } from '../../helpers/position-helper/position-helper';

export const dropdownComponentModule = angular
  .module('Q.components.dropdown', [positionHelperModule])

  .constant('dropdownConfig', {
    openClass: 'open',
  })

  .factory('dropdownService', function ($document, $rootScope) {
    let openScope = null;

    return {
      open(dropdownScope) {
        if (!openScope) {
          $document.bind('click', closeDropdown);
          $document.bind('keydown', escapeKeyBind);
        }

        if (openScope && openScope !== dropdownScope) {
          openScope.isOpen = false;
        }

        openScope = dropdownScope;
      },

      close(dropdownScope) {
        if (openScope === dropdownScope) {
          openScope = null;
          $document.unbind('click', closeDropdown);
          $document.unbind('keydown', escapeKeyBind);
        }
      },
    };

    function closeDropdown(evt) {
      // This method may still be called during the same mouse event that
      // unbound this event handler. So check openScope before proceeding.
      if (!openScope) {
        return;
      }

      // if requested, always ignore clicks
      if (evt && openScope.getAutoClose() === 'disabled') {
        return;
      }

      const eventIsIn = (el) => el && el[0].contains(evt.target);

      // always ignore the toggle (button) for this dropdown
      if (evt && eventIsIn(openScope.getToggleElement())) {
        return;
      }

      const $element = openScope.getElement();
      const $menu = openScope.getDropdownMenu();
      // if requested, ignore clicks inside the menu or anwhere in the dropdown
      if (
        evt &&
        openScope.getAutoClose() === 'outsideClick' &&
        (eventIsIn($element) || eventIsIn($menu))
      ) {
        return;
      }

      openScope.isOpen = false;

      // eslint-disable-next-line angular/no-private-call
      if (!$rootScope.$$phase) {
        openScope.$apply();
      }
    }

    function escapeKeyBind(evt) {
      if (evt.which === 27) {
        openScope.focusToggleElement();
        closeDropdown();
      }
    }
  })

  .controller(
    'DropdownCtrl',
    function (
      $scope,
      $attrs,
      $parse,
      dropdownConfig,
      dropdownService,
      $animate,
      $document,
      positionHelper,
      $timeout,
    ) {
      const ctrl = this;
      const scope = $scope.$new();
      // create a child scope so we are not polluting original one
      const openClass = dropdownConfig.openClass;
      let getIsOpen;
      let setIsOpen = angular.noop;
      const toggleInvoker = $attrs.onToggle
        ? $parse($attrs.onToggle)
        : angular.noop;
      let appendToBody = false;
      let dropUp = false;

      ctrl.init = function (element) {
        ctrl.$element = element;

        if ($attrs.isOpen) {
          getIsOpen = $parse($attrs.isOpen);
          setIsOpen = getIsOpen.assign;

          $scope.$watch(getIsOpen, function (value) {
            scope.isOpen = !!value;
          });
        }

        dropUp = element.hasClass('dropup');
      };

      ctrl.addDropdownMenu = (dropdownMenu) => {
        ctrl.dropdownMenu = dropdownMenu;
        appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
        if (appendToBody && dropdownMenu) {
          dropdownMenu.addClass('dropdown-in-body');
          $document.find('body').append(dropdownMenu);
          $scope.$on('$destroy', function handleDestroyEvent() {
            dropdownMenu.remove();
          });
        }
      };

      ctrl.toggle = function (open) {
        return (scope.isOpen = arguments.length ? !!open : !scope.isOpen);
      };

      // Allow other directives to watch status
      ctrl.isOpen = function () {
        return scope.isOpen;
      };

      scope.getToggleElement = function () {
        return ctrl.toggleElement;
      };

      scope.getDropdownMenu = function () {
        return ctrl.dropdownMenu;
      };

      scope.getAutoClose = function () {
        return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
      };

      scope.getElement = function () {
        return ctrl.$element;
      };

      scope.focusToggleElement = function () {
        if (ctrl.toggleElement) {
          ctrl.toggleElement.focus();
        }
      };

      let positionUnwatch = null;

      scope.$watch('isOpen', function (isOpen, wasOpen) {
        if (appendToBody && ctrl.dropdownMenu) {
          let positionEl = ctrl.$element;
          if (positionEl.querySelector('[dropdown-toggle]')) {
            positionEl = positionEl.querySelector('[dropdown-toggle]');
          }
          if (isOpen && !positionUnwatch) {
            let position = $attrs.dropdownPosition;
            if (!position || position[0] === '?') {
              position =
                (dropUp ? 'top' : positionHelper.topOrBottom(positionEl)) +
                (position ? position.slice(1) : '');
            }
            positionUnwatch = positionHelper.autoPositionPopup(
              scope,
              positionEl,
              ctrl.dropdownMenu,
              position,
              { setMinWidth: true },
            );
          } else if (!isOpen && positionUnwatch) {
            positionUnwatch();
            positionUnwatch = null;
          }
          $timeout(
            () => {
              ctrl.dropdownMenu.css({
                display: isOpen ? 'block' : 'none',
              });
            },
            0,
            false,
          );
        }

        $animate[isOpen ? 'addClass' : 'removeClass'](ctrl.$element, openClass);

        if (isOpen) {
          scope.focusToggleElement();
          dropdownService.open(scope);
        } else {
          dropdownService.close(scope);
        }

        setIsOpen($scope, isOpen);
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });

      $scope.$on('$locationChangeSuccess', function () {
        if (scope.getAutoClose() === 'always') {
          scope.isOpen = false;
        }
      });

      $scope.$on('$destroy', function () {
        scope.$destroy();
      });
    },
  )

  /**
   * @ngdoc directive
   * @name dropdown
   * @description
   * Creates a dropdown menu
   *
   * @restrict A
   * @element ANY
   * @param {expression} isOpen Value to manually toggle the menu
   * @param {expression} onToggle Callback when toggled
   * @param {*} dropdownAppendToBody If true, the dropdown is appended to the body
   * @param {template=} dropdownPosition Force the position of the dropdown
   * @param {template=} autoClose Change the closing behavior
   *
   * @example
   * <example>
   * <a track-click="event.name" track-data="{ properties }"></a>
   * </example>
   */
  .directive('dropdown', function () {
    return {
      restrict: 'A',
      controller: 'DropdownCtrl',
      link: function (scope, element, attrs, dropdownCtrl) {
        dropdownCtrl.init(element);
      },
    };
  })

  .directive('dropdownMenu', function () {
    return {
      restrict: 'A',
      require: '?^dropdown',
      link: function (scope, element, attrs, dropdownCtrl) {
        if (!dropdownCtrl) {
          return;
        }
        dropdownCtrl.addDropdownMenu(element);
      },
    };
  })

  .directive('dropdownToggle', function () {
    return {
      restrict: 'A',
      require: '?^dropdown',
      link: function (scope, element, attrs, dropdownCtrl) {
        if (!dropdownCtrl) {
          return;
        }

        dropdownCtrl.toggleElement = element;

        const toggleDropdown = function (event) {
          event.preventDefault();

          if (!element.hasClass('disabled') && !attrs.disabled) {
            scope.$apply(function () {
              dropdownCtrl.toggle();
            });
          }
        };

        element.bind('click', toggleDropdown);

        // WAI-ARIA
        element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
        scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
          element.attr('aria-expanded', !!isOpen);
        });

        scope.$on('$destroy', function () {
          element.unbind('click', toggleDropdown);
        });
      },
    };
  });
